import type { RouteRecordRaw } from "vue-router";
import groupRoutes from "./modules/group";
import workspaceRoutes from "./modules/workspace";
import boardRoutes from "./modules/board";
import powerRoutes from "./modules/power";
import trainRoutes from "./modules/train";
import aiAcademyRoutes from "./modules/aiAcademy";
import platformRoutes from "./modules/platform";
import spacesRoutes from "./modules/spaces";
import onboardingGuideRoutes from "./modules/onboardingGuide";

export const routes: RouteRecordRaw[] = [
  {
    path: "/",
    redirect: { name: "workbench" }
  },
  {
    path: "/home",
    name: "workbench",
    meta: {
      title: "pino",
      useTopbar: true,
      layout: "homeWorkbench"
    },
    component: () => import("@/views/workbench/index.vue")
  },
  {
    path: "/model",
    name: "model",
    meta: {
      label: "模型广场",
      layout: "homeWorkbench", // 使用粘性滚动布局（提供滚动容器上下文）
      type: "",
      visible: true,
      keepAlive: true,
      useTopbar: true,
      siderGroup: 1
    },
    component: () => import("@/views/model/index.vue")
  },
  {
    path: "/model/detail",
    name: "modelDetail",
    meta: {
      visible: false,
      auth: false,
      useTopbar: true,
      layout: "simple"
    },
    component: () => import("@/views/model/children/modelDetail.vue")
  },
  {
    path: "/model/:id",
    name: "model-detail",
    meta: {
      visible: false,
      auth: false,
      notUseSider: true,
      useTopbar: true,
      layout: "simple"
    },
    component: () => import("@/views/model/detail/index.vue")
  },
  {
    path: "/model/publish/:mode(new|edit|addNewVersion)?/:modelId?",
    name: "modelPublish",
    meta: {
      auth: true,
      notUseSider: true,
      useTopbar: true,
      layout: "simple"
    },
    component: () => import("@/views/model/children/ModelPublish.vue")
  },
  {
    path: "/image/:id",
    name: "image-detail",
    meta: {
      auth: false,
      notUseSider: true,
      useTopbar: true,
      layout: "simple",
      // 禁止 SimpleLayout 外层滚动，右栏内部滚动 + 底部操作常驻
      layoutHidden: true
    },
    component: () => import("@/views/image/detail/index.vue")
  },

  ...workspaceRoutes,
  ...powerRoutes,
  ...groupRoutes,
  ...trainRoutes,
  ...aiAcademyRoutes,
  ...groupRoutes,
  ...boardRoutes,
  ...platformRoutes,
  ...spacesRoutes,
  ...onboardingGuideRoutes,
  {
    path: "/invite",
    name: "invite",
    meta: {
      auth: true,
      layout: "simple",
      notUseSider: true,
      useTopbar: true
    },
    component: () => import("@/views/invite/index.vue")
  },
  {
    path: "/404",
    name: "404",
    meta: {
      visible: false,
      layout: "simple"
    },
    component: () => import("@/views/404/index.vue")
  },
  {
    path: "/403",
    name: "403",
    meta: {
      title: "访问受限",
      layout: "simple"
    },
    component: () => import("@/views/403/index.vue")
  },
  {
    path: "/aboutUs",
    name: "关于我们",
    meta: {
      visible: false,
      useTopbar: true,
      layout: "home"
    },
    component: () => import("@/views/aboutUs/index.vue")
  },

  {
    path: "/model-viewer",
    name: "modelViewer",
    meta: {
      auth: true,
      useTopbar: true,
      layout: "home"
    },
    component: () => import("@/views/ModelView.vue")
  },

  {
    path: "/imageDetails/:userId/:imageId",
    name: "imageDetails",
    meta: {
      auth: false,
      layout: "home",
      useTopbar: true
    },
    component: () => import("@/views/imageDetails/index.vue")
  },
  {
    path: "/shareModel/:modelCode",
    name: "shareModel",
    meta: {
      auth: false,
      layout: "home",
      requiresIPCheck: true,
      useTopbar: true
    },
    component: () => import("@/views/shareModel/index.vue")
  },
  {
    path: "/enterpriseInvestmentIntention",
    name: "enterpriseInvestmentIntention",
    meta: {
      auth: false,
      layout: "blank",
      notUseLayout: true,
      useTopbar: true
    },
    component: () => import("@/views/enterpriseInvestmentIntention/index.vue")
  },
  {
    path: "/personalCenter/:targetUid?",
    name: "personalCenter",
    meta: {
      auth: false,
      layout: "home",
      useTopbar: true
    },
    component: () => import("@/views/personalCenter/index.vue")
  },

  {
    path: "/invoiceCenter",
    name: "invoiceCenter",
    meta: {
      auth: true,
      layout: "simple",
      useTopbar: true
    },
    component: () => import("@/views/invoiceCenter/index.vue")
  },

  {
    path: "/debug/alipay-ai-subscription",
    name: "debugAlipayAiSubscription",
    meta: {
      label: "支付宝AI订阅调试",
      layout: "blank"
    },
    component: () => import("@/views/debug/AlipayAiSubscription/index.vue")
  },
  {
    path: "/playground",
    name: "playground",
    meta: {
      label: "演示",
      layout: "blank"
    },
    component: () => import("@/views/playground/index.vue")
    // src/components/Modals/MemberUpgradeSuccessModal/example.vue
    // component: () => import('@/components/Modals/MemberUpgradeSuccessModal/example.vue')
    /**
     * 订阅类升级为非订阅类的升级会员计划弹窗的各种使用场景
     */
    // component: () => import('@/components/Modals/MemberUpgradePlanModal/example.vue')
  },
  {
    path: "/:catchAll(.*)",
    redirect: "/"
  }
];
